import apiFn from 'common/services/api-service';

const moveEventApi = () =>
  apiFn('/api/cms/v1/action/move-event', {
    Accept: 'application/vnd.eventmobi+json; version=p.4',
  });

export const moveEvent = async data =>
  moveEventApi()
    .post('', data)
    .then(response => response.data);
